import type { MediaUploadJob } from "../_types/media-upload";

/**
 * True once the media service owns the bytes — `/final` succeeded. This is THE
 * gate every consumer waits on (a form saves, a message sends, a voice memo
 * attaches): the row turns `done` here, and processing (a HEIC → webp rewrite,
 * a video poster, the AI text) stays background work the person never waits
 * on. See docs/media.md §3 "The gates" and §6 "Frontend rules".
 */
export function hasBytesLanded(job: MediaUploadJob): boolean {
  return (
    job.attachmentId !== null &&
    (job.phase === "processing" || job.phase === "done")
  );
}
